<div class="" id="tab-three-c" *ngIf="allHistoryRequest.length > 0 && !showingDetailRequirementId">
  <h1 class="u-mb30 txt txt--title">
    Historial de solicitudes
  </h1>
  <ng-container>
    <div class="table-delegations">
      <div class="tr">
        <div class="th global-hand" [class.active]="order === 'asset'" (click)="setOrder('asset')">
          <div class="table-head headerTable">
            <p>Asset</p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'asset' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'asset' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'asset' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
              </div>

        </div>
        <div class="th global-hand" [class.active]="order === 'resquestType'" (click)="setOrder('resquestType')">
          <div class="table-head headerTable">
            <p> Tipo </p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'resquestType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'resquestType' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'resquestType' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'resquestType' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
         </div>
        </div>
        <div class="th global-hand" [class.active]="order === 'driverName'" (click)="setOrder('driverName')">
          <div class="table-head headerTable">
            <p>Conductor</p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'driverName' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'driverName' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'driverName' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'driverName' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
         </div>
        </div>
        <div class="th global-hand" [class.active]="order === 'requirementStatus'"
          (click)="setOrder('requirementStatus')">
          <div class="table-head headerTable" >
            <p>Estado </p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementStatus' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'requirementStatus' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementStatus' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'requirementStatus' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
        </div>
        </div>
        <div class="th global-hand" [class.active]="order === 'requirementId'" (click)="setOrder('requirementId')">
          <div class="table-head headerTable">
            <p> Nº solicitud </p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'requirementId' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementId' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'requirementId' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
         </div>
        </div>
        <div class="th global-hand" [class.active]="order === 'requirementDate'" (click)="setOrder('requirementDate')">
          <div class="table-head headerTable">
            <p>Fecha solicitud</p>
            <div class="sorting-arrows-container">
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementDate' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting ASC -->
                <div [hidden]="(order === 'requirementDate' && orderStatus === 2)" style="height: 11px; max-height: 11px;">
                  <app-table-sorting-arrow orientation="UP" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
              <div class="arrow-container">
                <!-- Sorting Disabled -->
                <div [hidden]="!(order === 'requirementDate' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="BLACK"></app-table-sorting-arrow>
                </div>
                <!-- Sorting DESC -->
                <div [hidden]="(order === 'requirementDate' && orderStatus === 3)">
                  <app-table-sorting-arrow orientation="DOWN" color="GREY"></app-table-sorting-arrow>
                </div>
              </div>
            </div>
        </div>
        </div>
        <div class="th" *ngIf="shouldShowDetailButtons">
          <div class="table-head headerTable">Más información</div>
        </div>
        <div *ngIf="shouldShowDeleteButtons" class="th textDelete" ></div>

      </div>
      <div class="tr"
        *ngFor=" let requirement of allHistoryRequest | orderBy: order :reverse : true | paginate : config ">
        <div class="td textContain" data-column="Asset">{{ requirement?.asset }}</div>
        <div class="td textContain" data-column="Tipo"> {{requirement?.requestType}} </div>
        <div class="td textContain" data-column="Conductor">{{requirement?.driverName}} </div>
        <div class="td textContain td--status statusIconRequest" data-column="Estado">
          <p>
            <img class="mr-2" [src]="imagesStatus[formatStatus(requirement?.requirementStatus)]">
            {{requirement?.requirementStatus}}
            <app-tooltip *ngIf="requirement?.requirementStatusComment"
              [text]="requirement?.requirementStatusComment"
            ></app-tooltip>
          </p>
        </div>
        <div class="td textContain" data-column="Nº solicitud">{{requirement?.requirementId}} </div>
        <div class="td textContain" data-column="Fecha solicitud">{{requirement?.requirementDate | dateFromBack }}
        </div>
        <div class="td textContain" *ngIf="shouldShowDetailButtons">
          <a class="td__action global-hand seeRequest" id="tab-three-b"
            (click)="onShowDetail(requirement?.requirementId)">Ver solicitud</a>
        </div>
        <div class="td containerDelete" *ngIf="shouldShowDeleteButtons">
          <a class="td__action td__action--delete modal__trigger eliminationText" data-modal="modal01"
            (click)="showModalConfirmEliminationRequest(requirement?.requirementId)"
            *ngIf="!(['Aprobada', 'Eliminado', 'Rechazada'].includes(requirement?.requirementStatus))">Eliminar</a>
        </div>
      </div>

    </div>

    <div class="u-right u-mt30" *ngIf="allHistoryRequest.length > 0">
      <pagination-template #p="paginationApi" [id]="config.id" (pageChange)="config.currentPage = $event">


        <div class="custom-pagination">
          <div class="pagination-previous" [class.disabled]="p.isFirstPage()">
            <span *ngIf="!p.isFirstPage()" (click)="p.previous()">< </span>
          </div>
          <div class="page-number" *ngFor="let page of p.pages" [class.current]="p.getCurrent() === page.value">
            <span (click)="p.setCurrent(page.value)" *ngIf="p.getCurrent() !== page.value">{{ page.label }}</span>
            <div *ngIf="p.getCurrent() === page.value">
              <span>{{ page.label }}</span>
            </div>
          </div>
          <div class="pagination-next" [class.disabled]="p.isLastPage()">
            <span *ngIf="!p.isLastPage()" (click)="p.next()"> > </span>
          </div>
        </div>

      </pagination-template>
    </div>
  </ng-container>
</div>

<div class="loader-licenses" *ngIf="allHistoryRequest.length === 0 && loadingData && showingDetailRequirementId === 0">
  <app-loader></app-loader>
</div>

<div *ngIf="allHistoryRequest.length === 0 && !loadingData">
  <h1 class="u-mb30 txt txt--title"> Historial de solicitudes </h1>
  <p *ngIf="historyRequestError !== '' "> {{historyRequestError}} </p>
  <p *ngIf="historyRequestError === '' " >No hay solicitudes registradas.</p>
  <a *ngIf="historyRequestError === '' " type="button" class="btn btn--primary" routerLink="/license/new">Crear una nueva solicitud de licencia</a>
</div>

<div *ngIf="!!showingDetailRequirementId">
  <app-license-detail [shouldShowDocumentLinks]="true" [requirementId]="showingDetailRequirementId" [shouldShowPersonalData]="true"
    (goBack)="onHideDetail()"></app-license-detail>
</div>

